import { render, staticRenderFns } from "./EventRedeem.vue?vue&type=template&id=bc6fb038&scoped=true&"
import script from "./EventRedeem.vue?vue&type=script&lang=js&"
export * from "./EventRedeem.vue?vue&type=script&lang=js&"
import style0 from "./EventRedeem.vue?vue&type=style&index=0&id=bc6fb038&scoped=true&lang=scss&"
import style1 from "./EventRedeem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6fb038",
  null
  
)

export default component.exports